import React from 'react'
import { withHandlers } from 'recompose'
import { TrashIcon } from '@infotech/uikit-icons'
import EquipmentFormatter from 'components/EquipmentFormatter'
import './equipment-field.scss'

const FormatterComponent = ({
  input: { value } = {},
  clearValue,
}) => (
  value
    ? (
      <div className="ej-equipment-field-formatter">
        <EquipmentFormatter value={value} />
        <div
          onClick={clearValue}
          className="ej-equipment-field-formatter-remove"
        >
          <TrashIcon
            size="medium"
            color="#f00"
          />
        </div>
      </div>
    )
    : null
)

const Formatter = (
  withHandlers({
    clearValue: ({ input: { onChange }, changeFormValue }) => () => {
      onChange(``)
      changeFormValue(`objectId`, ``)
      changeFormValue(`object`, ``)
    },
  })
)(FormatterComponent)

export default Formatter
